import TextInput, { MASKED_INPUT_PROPS } from './TextInput';

export default TextInput;
export { MASKED_INPUT_PROPS };
